import en from './en';
import zhHK from './zh_HK';

export default {
 'zh_HK': zhHK,
 'en': en,
}